import React from 'react';
import classNames from 'classnames';
import './Button.scss';

const Button: React.FC<{ 
    disabled?: boolean,
    click?: () => void, 
    children: string|number, 
    className?: any,
    type?: 'button'|'submit'|'reset'
}> = ({ click, children, className, type = 'button', disabled = false }) => (
    <button 
        disabled={disabled}
        type={type}
        className={classNames('btn MainButton', className)}
        onClick={click}>{children}
    </button>
);

export default Button;